import React, {useCallback, useEffect, useRef, useState} from "react";
import {
    Container,
    CalcFormCenter,
    CalcSection,
    CalcFieldRow,
    CalcInputWrap,
    CalcButtonWrap,
    CalcTableOuter,
    StyledTableContainer,
    TableHeadRow,
    TableHeadCell,
    TableBodyRow,
    TableBodyCell,
    calcPrimaryButtonStyle,
} from "./styles";
import InputMask from "../../../components/Form/InputMask";
import {currencyFormat} from "../../../utils/masks";
import {InputAdornment} from "@material-ui/core";
import {useSelector} from "react-redux";
import {toast} from "react-toastify";
import * as Yup from "yup";
import messageTypes from "../../../constants/MessagesTypes";
import CustomButton from "../../../components/Form/Button";
import {Form} from "@unform/web";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import {useTranslation} from "react-i18next";
import {FormWrapper} from "../../../styles/listPageTheme";

export default function Soros() {
    const { coinType} = useSelector((state) => state.BankReducer);
    const formRef = useRef(null);
    const [value, setValue] = useState(10);
    const [payout, setPayout] = useState(100);
    const [list, setList] = useState(null);
    const { t } = useTranslation();

    async function handleSubmit(data) {
        try {

            formRef.current.setErrors({});
            const schema = Yup.object().shape({
                value: Yup.string().required(t('input_required')),
                payout: Yup.string().required(t('input_required')),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            const dataValue = parseFloat(data.value.replace(/[^0-9,-]*/g, '').replace(',', '.'));
            const dataPayout = parseFloat(data.payout);
            if (!parseInt(dataValue) || !parseInt(dataPayout)) {
                toast.warning(t('calc_invalid_values'));
                return;
            }
            setValue(dataValue);
            setPayout(dataPayout);

        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    const updateList = useCallback(() => {
        let newList = [];
        let valueCalc = value;
        let resultCalc = valueCalc * payout / 100;
        let accumulated = valueCalc + resultCalc;
        for (let index = 0; index < 20; index++) {
            const item = {
                level: index + 1,
                value: valueCalc,
                result: resultCalc,
                accumulated: accumulated,
            };
            newList.push(item);

            valueCalc = valueCalc + resultCalc;
            resultCalc = valueCalc * payout / 100;
            accumulated = valueCalc + resultCalc;
        }

        setList(newList);
    }, [payout, value]);

    useEffect(updateList, [payout, value]);

    const buttonHoverIn = (e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.45)';
    };
    const buttonHoverOut = (e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = calcPrimaryButtonStyle.boxShadow;
    };

    return (
        <Container>
            <CalcFormCenter>
                <FormWrapper>
                    <Form ref={formRef} onSubmit={handleSubmit}>
                        <CalcSection>
                            <CalcFieldRow>
                                <CalcInputWrap>
                                    <InputMask
                                        size="small"
                                        type="text"
                                        name="value"
                                        label={t('calc_initial_value') + ' *'}
                                        mask={'currency'}
                                        defaultValue={currencyFormat(value)}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">{coinType}</InputAdornment>,
                                        }}
                                    />
                                </CalcInputWrap>
                                <CalcInputWrap>
                                    <InputMask
                                        size="small"
                                        type="text"
                                        name="payout"
                                        label={t('calc_payout') + ' *'}
                                        mask={'percent'}
                                        defaultValue={(payout).toFixed(2)}
                                        InputProps={{
                                            endAdornment: <InputAdornment position={'end'}>%</InputAdornment>,
                                        }}
                                    />
                                </CalcInputWrap>
                                <CalcButtonWrap>
                                    <CustomButton
                                        type="submit"
                                        style={calcPrimaryButtonStyle}
                                        onMouseEnter={buttonHoverIn}
                                        onMouseLeave={buttonHoverOut}
                                    >
                                        {t('calc_btn_calculate')}
                                    </CustomButton>
                                </CalcButtonWrap>
                            </CalcFieldRow>
                        </CalcSection>
                    </Form>
                </FormWrapper>
            </CalcFormCenter>

            <CalcTableOuter>
                <StyledTableContainer>
                    <Table
                        stickyHeader
                        size="small"
                        aria-label={t('calc_tab_soros')}
                    >
                        <TableHead>
                            <TableHeadRow>
                                <TableHeadCell align="center">{t('calc_level')}</TableHeadCell>
                                <TableHeadCell align="center">{t('calc_investment')}</TableHeadCell>
                                <TableHeadCell align="center">{t('calc_profit')}</TableHeadCell>
                                <TableHeadCell align="center">{t('calc_accumulated_profit')}</TableHeadCell>
                            </TableHeadRow>
                        </TableHead>
                        <TableBody>
                            {list && list.length > 0 && list.map((row, index) => (
                                <TableBodyRow key={index}>
                                    <TableBodyCell align="center" component="th" scope="row">
                                        {row.level}
                                    </TableBodyCell>
                                    <TableBodyCell align="center" className="calc-cell-num">
                                        {coinType} {currencyFormat(row.value)}
                                    </TableBodyCell>
                                    <TableBodyCell align="center" className="calc-cell-num">
                                        {coinType} {currencyFormat(row.result)}
                                    </TableBodyCell>
                                    <TableBodyCell align="center" className="calc-cell-num">
                                        {coinType} {currencyFormat(row.accumulated - value)}
                                    </TableBodyCell>
                                </TableBodyRow>
                            ))}
                        </TableBody>
                    </Table>
                </StyledTableContainer>
            </CalcTableOuter>
        </Container>
    );
}
